module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/222-niger-064cc02b0df80327db2e1d542ac0d2e8.svg";